// extracted by mini-css-extract-plugin
module.exports = {"tooltipHolder":"styles_tooltipHolder__Cn2Iq"};